import { render, staticRenderFns } from "./passengeDetailsComponent.vue?vue&type=template&id=ea6ab2c0&"
import script from "./passengeDetailsComponent.vue?vue&type=script&lang=js&"
export * from "./passengeDetailsComponent.vue?vue&type=script&lang=js&"
import style0 from "./passengeDetailsComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "passengeDetailsComponent.vue"
export default component.exports